<style lang="scss" scoped>
.browserCheck {
  display: grid;
  grid-template-columns: 1fr 240px;
  font-size: 16px;
  background-color: #f2f2f2;
  padding: 0 20px;
}
.warn-red {
  color: #ff0000;
}
.right-div {
  margin: 10px 0;
  border: 1px solid #c9c9c9;
  background-color: #fff;
  padding: 10px 8px;
  line-height: 20px;
  text-align: center;
  color: #666;
  div {
    text-align: center;
  }
}
</style>
<template>
  <el-dialog
    center
    title="提示"
    :visible="dialogVisible"
    @update:visible="relayUpdateVisible"
    :close-on-click-modal="false"
    :show-close="false"
    width="50%"
  >
    <div>
      <div class="browserCheck" v-show="!browserOk">
        <div>
          <p>浏览器检测</p>
          <p v-show="browserOk">您的浏览器通过了检测，可以继续考试。</p>
          <template>
            <p v-show="!browserOk">
              <p class="warn-red">浏览器版本太低，为保证考试正常运行，</p>
              <p class="warn-red">请使用谷歌浏览器72或以上版本进行考试！</p>
              <!-- <span class="warn-red">浏览器版本太低，为保证考试正常运行，请使用谷歌浏览器72或以上版本进行考试！</span> -->
              <p>
                <a
                    target="_blank"
                    href="https://www.google.cn/chrome/"
                  >Chrome下载地址
                </a>
              </p>
            </p>
          </template>
        </div>
        <div class="right-div">
          <div>
            <img :src="browserImg" alt />
          </div>
          <p>
            <!-- <span>版本:</span><span>{{browser.version}}</span><br/> -->
            当前浏览器:<span>{{browser.name}}</span>
          </p>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import codepku from '../utils/codepku';
import googleImg from '../assets/images/1.png';
import fireImg from '../assets/images/2.png';
import ieImg from '../assets/images/3.png';
import operaImg from '../assets/images/4.png';
import safariImg from '../assets/images/5.png';
const browser = codepku.browserType();

export default {
  data() {
    return {
      browser,
      browserOk: true,
    };
  },
  methods: {
    relayUpdateVisible(val) {
      this.$emit('update:dialogVisible', val);
    },
    handleConfirm() {
      this.$emit('update:dialogVisible', false);
      localStorage.clear();
      location.href = '/login';
    },
  },

  created() {
    // console.log(this.myExam,'mymyym');
  },
  mounted() {
    const type = this.browser.type.toLowerCase();
    const version = parseInt(this.browser.version, 10);
    if (type === 'chrome' && version >= 72) {
      this.browserOk = true;
    } else {
      this.browserOk = false;
      this.$emit('update:dialogVisible', true);
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    myExam: {
      type: Object
    }
  },
  computed: {
    browserImg() {
      console.log(this.browser.type.toLowerCase());
      switch (this.browser.type.toLowerCase()) {
        case 'chrome':
          return googleImg;
        case 'firefox':
          return fireImg;
        case 'ie':
          return ieImg;
        case 'opera':
          return operaImg;
        case 'safari':
          return safariImg;
        default:
          return '';
      }
    },
    shouldShowDialog() {
      return (
        !this.browserOk
      );
    },
  },
  watch: {
    shouldShowDialog(val) {
      if (val) {
        this.$emit('update:dialogVisible', true);
      } else {
        this.$emit('update:dialogVisible', false);
      }
    },
  },
};
</script>
